<template>
  <div>
    <div class="grid grid-cols-1 lg:grid-cols-12 p-6 lg:py-11">
      <div :class="{ 'order-2': !showTextOnLeftSide, 'lg:col-span-5 z-10': true }">
        <div class="flex h-full w-full justify-center items-center">
          <div
            class="bg-white p-10 rounded-sm w-[90%] lg:w-[120%] z-10"
            :class="{
              'mb-[-10%] lg:mb-0 lg:mr-[-20%]': showTextOnLeftSide,
              'mt-[-10%] lg:mt-0 lg:ml-[-20%]': !showTextOnLeftSide,
            }"
          >
            <p class="text-xl lg:text-4xl font-playfair font-bold mb-4 text-primary-bravo">
              {{ quoteContent }}
            </p>
            <span class="text-base font-light">
              {{ nameAndTitle }}
            </span>
          </div>
        </div>
      </div>

      <div :class="{ 'order-1': !showTextOnLeftSide, 'lg:col-span-7': true }">
        <img
          :src="imageUrl"
          alt=""
          class="w-full h-full object-cover rounded-sm aspect-square lg:max-h-[502px]"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KfQuoteImage',
  props: {
    imageUrl: {
      type: String,
      default: () => '',
    },
    quoteContent: {
      type: String,
      default: () => '',
    },
    nameAndTitle: {
      type: String,
      default: () => '',
    },
    showTextOnLeftSide: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
